<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Journalnummer</mat-panel-title>
  </mat-expansion-panel-header>
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Format (generelt)</dt>
        <dd>
          <mat-chip-set>
            @for (element of pattern; track element) {
              <mat-chip>{{element.label}}</mat-chip>
            }
          </mat-chip-set>
        </dd>
        <dt>Eksempel</dt>
        <dd>{{ sample }}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Kontinuert løbenummer</dt>
        <dd>{{ continuousRunningNumber ? 'Ja' : 'Nej' }}</dd>
        <dt>Års skifte</dt>
        <dd>{{ cutover | date:'d. MMMM'}}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <div fxLayout="column" class="mb-3">
            <label>Format</label>
            <app-pattern-editor
              [control]="patternCtrl"
              [pattern]="value.pattern"
              [category]="'KAT'"
              (patternChanged)="onPatternChanged($event)">
            </app-pattern-editor>
          </div>
        </div>
        <div fxFlex="45" fxLayout="column">
          <label>Kontinuert løbenummer <small>(Løbenummer genstarter ikke ved års skifte)</small></label>
          <mat-slide-toggle class="mb-3" formControlName="continuous_running_number"></mat-slide-toggle>

          <label>Års skifte <small>(Hvilken måned/dag, skifter journal nummeret år)</small></label>
          <mat-form-field class="mb-3">
            <mat-label>Måned</mat-label>
            <mat-select formControlName="cutover_month">
              <mat-option [value]="1">Januar</mat-option>
              <mat-option [value]="2">Februar</mat-option>
              <mat-option [value]="3">Marts</mat-option>
              <mat-option [value]="4">April</mat-option>
              <mat-option [value]="5">Maj</mat-option>
              <mat-option [value]="6">Juni</mat-option>
              <mat-option [value]="7">Juli</mat-option>
              <mat-option [value]="8">August</mat-option>
              <mat-option [value]="9">September</mat-option>
              <mat-option [value]="10">Oktober</mat-option>
              <mat-option [value]="11">November</mat-option>
              <mat-option [value]="12">December</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mb-3">
            <mat-label>Dag</mat-label>
            <mat-select formControlName="cutover_day">
              <mat-option [value]="1">1.</mat-option>
              <mat-option [value]="2">2.</mat-option>
              <mat-option [value]="3">3.</mat-option>
              <mat-option [value]="4">4.</mat-option>
              <mat-option [value]="5">5.</mat-option>
              <mat-option [value]="6">6.</mat-option>
              <mat-option [value]="7">7.</mat-option>
              <mat-option [value]="8">8.</mat-option>
              <mat-option [value]="9">9.</mat-option>
              <mat-option [value]="10">10.</mat-option>
              <mat-option [value]="11">11.</mat-option>
              <mat-option [value]="12">12.</mat-option>
              <mat-option [value]="13">13.</mat-option>
              <mat-option [value]="14">14.</mat-option>
              <mat-option [value]="15">15.</mat-option>
              <mat-option [value]="16">16.</mat-option>
              <mat-option [value]="17">17.</mat-option>
              <mat-option [value]="18">18.</mat-option>
              <mat-option [value]="19">19.</mat-option>
              <mat-option [value]="20">20.</mat-option>
              <mat-option [value]="21">21.</mat-option>
              <mat-option [value]="22">22.</mat-option>
              <mat-option [value]="23">23.</mat-option>
              <mat-option [value]="24">24.</mat-option>
              <mat-option [value]="25">25.</mat-option>
              <mat-option [value]="26">26.</mat-option>
              <mat-option [value]="27">27.</mat-option>
              <mat-option [value]="28">28.</mat-option>
              <mat-option [value]="29">29.</mat-option>
              <mat-option [value]="30">30.</mat-option>
              <mat-option [value]="31">31.</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button id="edit" (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button id="do-save" mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
